<script>
  export default {
    name: 'button-rd',
    props: ['variant', 'disabled', 'fluid', 'leftIcon', 'color', 'click', 'rightIcon'],
    data() {
      return {
        isHovered: false,
      }
    },
    computed: {
      className() {
        return {
          'color-primary': this.color === 'primary',
          'button-primary': this.variant === 'primary',
          'button-outline': this.variant === 'outline',
          'button-dark': this.variant === 'dark',
          'button-hovered': this.isHovered,
          'button-disabled': this.disabled,
          'button-full': this.fluid,
          'button-default': this.variant === 'default',
        }
      },
    }
  }
</script>

<template>
    <button
        class="button-base text-16 fw-500 cursor-pointer"
        :class="className"
        @mouseover="isHovered = true"
        @mouseleave="isHovered = false"
        :disabled="disabled"
    >
      <icon-rd v-if="leftIcon" :name="leftIcon" :color="disabled ? 'disabled' : color" />
      <slot />
      <icon-rd v-if="rightIcon" :name="rightIcon" :color="disabled ? 'disabled' : color" />
    </button>
</template>

<style lang="less" scoped>
@import "../../less/redesign/base.less";

.cursor-pointer {
  cursor: pointer;
}

.button-base {
  text-wrap: nowrap;
  padding: 8px 24px;
  border-radius: 40px;
  color: @primary-dark;
  outline: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button-default {
  background-color: transparent !important;
  border: none !important;
  font-weight: 700;
}
.button-primary {
  background-color: @primary-blue;
  border: 1px solid @primary-blue;
  color: @primary-light;
}
.button-disabled {
  background-color: @grey-hover;
  border: 1px solid @grey-hover;
  color: @grey-input;
  pointer-events: none;
}
.button-outline {
  background-color: transparent;
  color: @primary-dark;
  border: 1px solid @primary-blue;
}
.button-dark {
  background-color: #555555;
  color: #ffffff;
  border: none;
  &.button-hovered {
    background-color: #adadad;
    color: #ffffff;
    border: none;
  }
}
.button-hovered {
  background-color: @secondary-active;
  border: 1px solid @secondary-active;
}
.button-full {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/ui/button/Button.vue